var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDislike = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dislike"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0133 3.76669L8.94664 2.16669C8.67998 1.90002 8.07998 1.76669 7.67998 1.76669H5.14664C4.34664 1.76669 3.47998 2.36669 3.27998 3.16669L1.67998 8.03336C1.34664 8.96669 1.94664 9.76669 2.94664 9.76669H5.61331C6.01331 9.76669 6.34664 10.1 6.27998 10.5667L5.94664 12.7C5.81331 13.3 6.21331 13.9667 6.81331 14.1667C7.34664 14.3667 8.01331 14.1 8.27998 13.7L11.0133 9.63336",
    strokeMiterlimit: 10,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4133 3.76669V10.3C14.4133 11.2334 14.0133 11.5667 13.08 11.5667H12.4133C11.48 11.5667 11.08 11.2334 11.08 10.3V3.76669C11.08 2.83336 11.48 2.50002 12.4133 2.50002H13.08C14.0133 2.50002 14.4133 2.83336 14.4133 3.76669Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDislike);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dislike.59bfa31857735149ff8c2d371750855c.svg";